import { menuConfig } from '@/config/menu.config';
import { useUserStore } from '@/store';
import { MenuItemType, type MenuList } from '@/types/menu.type';
import NotFound from '@/views/error/NotFound';
import React from 'react';
import type { RouteObject } from 'react-router-dom';

export type PageModule = {
  default: React.ComponentType;
};

const resolveComponent = (path: string) => {
  try {
    return React.lazy(() => import(`@/views${path}.tsx`));
  } catch (error) {
    console.error(`Failed to load component for path: ${path}`, error);
    return null;
  }
};

export const createRouteElement = (path: string) => {
  const Comp = resolveComponent(path);

  if (!Comp) return <NotFound />;

  return (
    <React.Suspense fallback={<>loading...</>}>
      <Comp />
    </React.Suspense>
  );
};

export const generateRoutes = (menus: MenuList): RouteObject[] => {
  return menus
    .filter(
      (menu) =>
        menu.type === MenuItemType.Menu || menu.type === MenuItemType.Route
    )
    .map((menu) => {
      return {
        path: menu.path,
        element: menu.component
          ? createRouteElement(menu.component)
          : undefined,
        children: menu.children ? generateRoutes(menu.children) : undefined,
      };
    });
};

export function useRoutes() {
  const { user } = useUserStore();
  return generateRoutes(user?.menuList || menuConfig);
}
